// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import propTypes from 'prop-types';

import { Button, PlusCircleIcon } from '@metarouter-private/mr-mui';
import { isAllowedToInsertConsentCategory } from '@ion/api/consent-categories/insert/insert-consent-category-permission';
import useHasConsentModule from './useHasConsentModule';

export default function AddCategoryButton({ onAddCategory }) {
  const isAllowedToAddCategory = useIsAllowedToAddCategory();
  return (
    <Button startIcon={<PlusCircleIcon />} onClick={onAddCategory} disabled={!isAllowedToAddCategory} size="large">
      Add Category
    </Button>
  );
}

export function useIsAllowedToAddCategory() {
  const hasConsentModule = useHasConsentModule();
  const hasPermissions = isAllowedToInsertConsentCategory();
  return hasPermissions && hasConsentModule;
}

AddCategoryButton.propTypes = {
  onAddCategory: propTypes.func.isRequired,
};
